import { render, staticRenderFns } from "./tickets-sub-type.vue?vue&type=template&id=85fe1fe6&"
import script from "./tickets-sub-type.vue?vue&type=script&lang=js&"
export * from "./tickets-sub-type.vue?vue&type=script&lang=js&"
import style0 from "./tickets-sub-type.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports